module.exports = __webpack_public_path__ + "static/media/Likehover.baa62b80.svg";